module.exports = __webpack_public_path__ + "img/articleheader.46e9986e.jpg";